import { Edit } from '@mui/icons-material';
import {
  Button, FormControl, Grid, IconButton, Dialog,
  TextField, Typography, FormLabel, Autocomplete
} from '@mui/material';
import React, { useState, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import formDataToObj from '../../utils/formDataToObj';
import fileUpload from '../../services/fileUpload';
import { InfoContext } from '../../services/Context/Info/context';
import Banner from '../../services/db/banner';
import {COUNTRY_INDIA} from "../../constants/india"



function AddBanner({ data = {}  }) {
  const [open, setOpen] = useState(false);
  const [info, setInfo] = useState(data);
  const [locationInput, setLocationInput] = useState('');
  const { data: { bannerData }, setData } = useContext(InfoContext);

  const filteredOptions = useMemo(() => {
    if (!locationInput) return [];
  
    const alreadyAddedLocations = bannerData.map(b => b.location?.toLowerCase());
  
    return COUNTRY_INDIA.filter(entry => {
      const state = entry.state.toLowerCase();
      return state.includes(locationInput.toLowerCase()) && !alreadyAddedLocations.includes(state);
    }).map(entry => entry.state);
  }, [locationInput, bannerData]);

  const handleChange = async (e) => {
    if (e.target.files?.[0] instanceof File) {
      fileUpload(e.target.files[0], (url) => {
        setInfo(prev => ({ ...prev, [e.target.name]: url }));
      });
    } else {
      setInfo(prev => ({ ...prev, [e.target.name]: e.target.value }));
    }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    const prm = await formDataToObj(info);
    new Banner().addBanner(prm).then((r) => {
      setInfo({});
      setOpen(false);
      if (prm.id) {
        const ind = bannerData.findIndex(el => el.id === prm.id);
        if (ind !== -1) {
          let c = bannerData.map((el, _id) => (_id === ind ? prm : el));
          setData(p => ({ ...p, bannerData: c }));
        }
      } else {
        setData(p => ({ ...p, bannerData: [...bannerData, { ...prm, id: r }] }));
      }
    });
  };

  return (
    <>
      {!data.id ?
        <Button color='secondary' variant='contained' onClick={() => setOpen(true)}>
          Add Banner
        </Button> :
        <IconButton onClick={() => setOpen(true)}>
          <Edit />
        </IconButton>
      }

      <Dialog open={open} onClose={() => setOpen(false)}>
        <Grid container sx={{ backgroundColor: 'white' }} spacing={2} padding={2}>
          <Grid item xs={12}>
            <Typography variant="h6">Add Banner</Typography>
          </Grid>

          {/* Image Upload */}
          <Grid item xs={12}>
            <FormControl fullWidth>
              <FormLabel>Photo</FormLabel>
              <TextField
                size='small'
                name="photo"
                type="file"
                fullWidth
                accept='image/*'
                onChange={handleChange}
              />
            </FormControl>
          </Grid>

          {/* Link Field */}
          <Grid item xs={12}>
            <FormControl fullWidth>
              <FormLabel>Link</FormLabel>
              <TextField
                size='small'
                name="link"
                value={info?.link || ''}
                fullWidth
                onChange={handleChange}
                placeholder='Enter Your Link'
              />
            </FormControl>
          </Grid>

          {/* Location Select */}
          <Grid item xs={12}>
            <FormControl fullWidth>
              <FormLabel>Location (State)</FormLabel>
              <Autocomplete
                freeSolo
                options={filteredOptions}
                inputValue={locationInput}
                value={info?.location || ''}
                onInputChange={(event, value, reason) => {
                  if (reason === 'clear') {
                    setInfo(prev => ({ ...prev, location: '' }));
                    setLocationInput('');
                  } else {
                    setLocationInput(value);
                  }
                }}
                onChange={(event, value) => {
                  setInfo(prev => ({ ...prev, location: value }));
                  setLocationInput(value || '');
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="location"
                    placeholder="Search for a state"
                    size="small"
                    fullWidth
                  />
                )}
              />
            </FormControl>
          </Grid>

          {/* Submit */}
          <Grid item xs={12}>
            <Button variant='contained' color='primary' onClick={handleAdd}>
              Submit
            </Button>
          </Grid>

      
        </Grid>
      </Dialog>
    </>
  );
}

AddBanner.propTypes = {
  data: PropTypes.shape({})
};

export default AddBanner;
